import { jsx, jsxs } from 'react/jsx-runtime';
import { ArrowRight } from '@dls/assets/icons';
import React__default, { useState, useCallback } from 'react';
import { SDMarginDiv, SDBlockDiv, SCAnchorBlack, SubMenu, SubMenuDiv } from './styles.js';
import { onServiceClick } from '../service.js';
import theme from '../../../../../theme/index.js';
import '../../../../../../../authentication/context/AuthenticationProvider.js';
import '@geit/ui-components';
import { useAppConfig } from '../../../../../../../authentication/hooks/useAppConfig.js';
import { useCurrentUser } from '../../../../../../../authentication/hooks/useCurrentUser.js';
import { useNavigate } from '../../../../../../../authentication/hooks/useNavigate.js';
import { usePermission } from '../../../../../../../authentication/hooks/usePermission.js';
import { useToken } from '../../../../../../../authentication/hooks/useToken.js';
import '../../../../../../../authentication/navigate.js';
import '../../../../../../StyleComponents/SCContainerStyledComponent.js';
import '../../../../../../StyleComponents/SCDivStyledComponents.js';
import { SCTextStyledComponent } from '../../../../../../StyleComponents/SCTextStyledComponent.js';
import { TextTruncate } from '../../../../../../StyleComponents/style.js';
import 'styled-components';
import { transformMenuUrl } from '../../../../../helpers/utils.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const DesktopSubMenu = _ref => {
  let {
    baseUrl,
    subMenuItems = [],
    menuHoverKey,
    onMenuMouseEnter,
    onMenuMouseLeave,
    theme: theme$1,
    title,
    parentId,
    close,
    eshopBRNs,
    onClickMenu
  } = _ref;
  var _a;
  const {
    getPermission
  } = usePermission("", void 0, true);
  const config = useAppConfig();
  const {
    fetchToken
  } = useToken();
  const {
    user
  } = useCurrentUser();
  const currentBRN = (_a = user.entitySelection) == null ? void 0 : _a.refNumber;
  const [subMenuHoverKey, setSubMenuHoverKey] = useState(-1);
  const navigate = useNavigate();
  const onSubMenuMouseEnter = useCallback(key => {
    setSubMenuHoverKey(key);
  }, []);
  const onSubMenuMouseLeave = useCallback(key => {
    setSubMenuHoverKey(key);
  }, []);
  const onMouseEnter = useCallback((e, key) => {
    const target = e.target;
    const pNode = target.parentNode;
    const node = pNode == null ? void 0 : pNode.nextSibling;
    const parentNode = pNode == null ? void 0 : pNode.parentNode;
    const rootNode = document.getElementById(parentId);
    if (node && parentNode && rootNode) {
      const maxHeight = findMaxHeight(node, parentId, 0);
      rootNode.style.height = maxHeight + "px";
    } else {
      const maxHeight = findMaxHeight(pNode, parentId, 0);
      if (rootNode) {
        rootNode.style.height = maxHeight + "px";
      }
    }
    onMenuMouseEnter(key);
    setSubMenuHoverKey(-1);
  }, []);
  const findMaxHeight = useCallback((node, rootId, minHeight) => {
    const nodeHeight = node == null ? void 0 : node.offsetHeight;
    const maxHeight = nodeHeight > minHeight ? nodeHeight : minHeight;
    const parentNode = node.parentNode;
    if (parentNode && parentNode.id !== rootId) {
      return findMaxHeight(parentNode, rootId, maxHeight);
    } else {
      return maxHeight;
    }
  }, []);
  return /* @__PURE__ */jsx(SDMarginDiv, {
    children: subMenuItems.map((subMenu, index) => {
      var _a2;
      const subItem = subMenu.subMenu ? subMenu.subMenu.filter(menu => !menu.item.hide) : [];
      const oneItem = subItem.length === 1 && subMenu.item.title === subItem[0].item.title;
      const haveSubMenu = subItem.length > 0 && !oneItem;
      const showSubMenu = menuHoverKey === index && haveSubMenu;
      let href = oneItem ? subMenu.item.external ? subMenu.subMenu[0].item.href : baseUrl + subMenu.subMenu[0].item.href : subMenu.item.href;
      const featureCode = oneItem ? subMenu.subMenu[0].item.featureCode : subMenu.item.featureCode;
      href = transformMenuUrl({
        url: href,
        isEShopMenu: subMenu.item.isEShopMenu,
        eshopBRNs,
        currentBRN,
        featureCode,
        sector: (_a2 = user.entitySelection) == null ? void 0 : _a2.sector
      });
      return /* @__PURE__ */jsxs(React__default.Fragment, {
        children: [index === 0 && /* @__PURE__ */jsx(SCTextStyledComponent, {
          css: TextTruncate,
          type: "boldBody",
          children: title
        }), !subMenu.item.hide && /* @__PURE__ */jsx("div", {
          children: /* @__PURE__ */jsxs(SDBlockDiv, {
            onMouseEnter: e => onMouseEnter(e, index),
            onMouseLeave: () => onMenuMouseLeave(index),
            children: [/* @__PURE__ */jsxs(SCAnchorBlack, {
              href: href === "" ? "#" : href,
              onClick: e => onServiceClick({
                e,
                menuItem: __spreadProps(__spreadValues({}, subMenu), {
                  item: __spreadProps(__spreadValues({}, subMenu.item), {
                    href
                  })
                }),
                currentBRN,
                navigate,
                config,
                fetchToken,
                getPermission,
                close,
                onClickMenu
              }),
              theme: theme$1,
              children: [/* @__PURE__ */jsx(SCTextStyledComponent, {
                css: TextTruncate,
                type: "smallBody",
                children: subMenu.item.title
              }), haveSubMenu && /* @__PURE__ */jsx(ArrowRight, {
                color: theme.colours.grey_a8
              })]
            }), haveSubMenu && /* @__PURE__ */jsx(SubMenu, {
              visible: showSubMenu,
              children: /* @__PURE__ */jsx(SubMenuDiv, {
                children: /* @__PURE__ */jsx(DesktopSubMenu, {
                  subMenuItems: subMenu.subMenu,
                  menuHoverKey: subMenuHoverKey,
                  onMenuMouseEnter: onSubMenuMouseEnter,
                  onMenuMouseLeave: onSubMenuMouseLeave,
                  theme: theme$1,
                  title: subMenu.item.title,
                  parentId,
                  baseUrl,
                  close,
                  eshopBRNs,
                  onClickMenu
                })
              })
            })]
          }, index)
        })]
      }, index);
    })
  });
};
export { DesktopSubMenu as default };